import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useGetOrganizers } from '../api/organizerAdmin';
import { AlertCircle, Globe, Mail, Zap } from 'lucide-react';
import './OrganizerAdmin.css';

const OrganizerList: React.FC = () => {
  const { data, isLoading, error } = useGetOrganizers();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return (
      <div className="app">
        <Header />
        <main className="main-content">
          <div className="admin-loading">
            <div className="loading-spinner"></div>
            <p>Loading organizers...</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="app">
        <Header />
        <main className="main-content">
          <div className="admin-error">
            <AlertCircle className="icon icon--xl" />
            <h2>Error Loading Organizers</h2>
            <p>Unable to load organizers. Please try again.</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <div className="admin-container">
          <div className="admin-header">
            <h1 className="admin-title">Organizers</h1>
            <p className="admin-subtitle">{data?.organizers.length ?? 0} organizers</p>
          </div>
          <ul className="organizer-list">
            {data?.organizers.map((organizer) => (
              <li key={organizer.id} className="organizer-list__item">
                <div className="organizer-list__main">
                  <Link to={`/admin/organizer/${organizer.id}`} className="organizer-list__name">
                    {organizer.name}
                  </Link>
                  {organizer.instant_booking && (
                    <span className="organizer-list__badge organizer-list__badge--instant">
                      <Zap size={12} />
                      Instant booking
                    </span>
                  )}
                </div>
                <div className="organizer-list__meta">
                  {(organizer.city || organizer.state) && (
                    <span className="organizer-list__meta-item">
                      {[organizer.city, organizer.state].filter(Boolean).join(', ')}
                    </span>
                  )}
                  {organizer.email && (
                    <a href={`mailto:${organizer.email}`} className="organizer-list__meta-item">
                      <Mail size={13} />
                      {organizer.email}
                    </a>
                  )}
                  {organizer.website && (
                    <a href={organizer.website} target="_blank" rel="noopener noreferrer" className="organizer-list__meta-item">
                      <Globe size={13} />
                      {organizer.website}
                    </a>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OrganizerList;
